var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMessenger({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0009 19.5004C40.0009 30.2707 31.0507 39.0008 20.0004 39.0008C18.3494 39.0008 16.7504 38.8068 15.2163 38.4368C14.7513 38.3248 14.2653 38.3678 13.8373 38.5818L9.46021 40.7709C8.33018 41.3359 7.00015 40.5139 7.00015 39.2498V35.2248C7.00015 34.6497 6.74315 34.1137 6.31914 33.7257C2.42505 30.1656 0 25.1105 0 19.5004C0 8.73019 8.95019 0 20.0004 0C31.0507 0 40.0009 8.73019 40.0009 19.5004Z",
    fill: "url(#paint0_radial_985_1887)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M30.9929 13.2922C30.5649 13.2922 30.1499 13.4342 29.7929 13.7032L24.0987 17.9183C23.9657 18.0183 23.8187 18.0683 23.6637 18.0683C23.5137 18.0683 23.3727 18.0213 23.2537 17.9323L19.2816 14.9423C18.4736 14.3413 17.5216 14.0243 16.5246 14.0243C14.9485 14.0243 13.4995 14.8153 12.6485 16.1403L11.4375 18.0313L7.31737 24.7265C6.92536 25.3405 6.89536 26.0985 7.24637 26.7405C7.60438 27.3945 8.28039 27.8005 9.01041 27.8005C9.43842 27.8005 9.85343 27.6585 10.2104 27.3895L15.9046 23.1744C16.0376 23.0744 16.1846 23.0244 16.3396 23.0244C16.4896 23.0244 16.6306 23.0714 16.7496 23.1604L20.7217 26.1505C21.5307 26.7525 22.4817 27.0685 23.4787 27.0685C25.0548 27.0685 26.5038 26.2775 27.3548 24.9525L28.5658 23.0614L32.6859 16.3663C33.0779 15.7523 33.1079 14.9943 32.7569 14.3523C32.3989 13.6982 31.7229 13.2922 30.9929 13.2922Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M30.9931 13.7922C30.6741 13.7922 30.3631 13.8992 30.0941 14.1022L24.397 18.3203C24.181 18.4833 23.929 18.5683 23.665 18.5683C23.406 18.5683 23.1609 18.4863 22.9549 18.3323L18.9819 15.3413C18.2628 14.8063 17.4138 14.5243 16.5248 14.5243C15.1198 14.5243 13.8287 15.2293 13.0697 16.4113L11.8597 18.3023L7.74461 24.9905C7.44761 25.4555 7.42461 26.0235 7.68661 26.5015C7.95262 26.9875 8.47363 27.3015 9.01164 27.3015C9.33065 27.3015 9.64165 27.1945 9.91066 26.9915L15.6078 22.7734C15.8238 22.6104 16.0758 22.5254 16.3398 22.5254C16.5988 22.5254 16.8438 22.6074 17.0498 22.7614L21.0229 25.7525C21.7419 26.2875 22.5909 26.5695 23.48 26.5695C24.885 26.5695 26.176 25.8645 26.935 24.6825L28.1451 22.7914L32.2601 16.1033C32.5572 15.6383 32.5802 15.0703 32.3181 14.5923C32.0521 14.1062 31.5321 13.7922 30.9931 13.7922Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3947 14.5012L24.6946 18.7213C24.0845 19.1813 23.2545 19.1813 22.6545 18.7313L18.6804 15.7403C17.0004 14.4902 14.6203 14.9202 13.4903 16.6803L12.2803 18.5703L8.1702 25.2505C7.57019 26.1905 8.72021 27.2605 9.61023 26.5905L15.3104 22.3704C15.9204 21.9104 16.7504 21.9104 17.3504 22.3604L21.3245 25.3515C23.0045 26.6015 25.3846 26.1715 26.5146 24.4114L27.7246 22.5214L31.8347 15.8413C32.4347 14.9012 31.2847 13.8312 30.3947 14.5012Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_985_1887",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.08715 38.9788) scale(47.613 47.613)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.079,
    stopColor: "#001418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#001418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#001418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    stopColor: "#001418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754,
    stopColor: "#001418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "#001418"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessenger);
export default __webpack_public_path__ + "static/media/icon-messenger.627956eebbd1ed81a15804aed6edeb6d.svg";
export { ForwardRef as ReactComponent };